var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9491 2C7.65509 2 4.98474 4.67035 4.98474 7.96439V12.939C4.98474 13.6616 4.79237 14.3393 4.45605 14.9237H17.4422C17.1059 14.3393 16.9135 13.6616 16.9135 12.939V7.96439C16.9135 4.67035 14.2432 2 10.9491 2ZM20.8983 14.9237C19.8021 14.9237 18.9135 14.0351 18.9135 12.939V7.96439C18.9135 3.56578 15.3477 0 10.9491 0C6.55052 0 2.98474 3.56578 2.98474 7.96439V12.939C2.98474 14.0351 2.09614 14.9237 1 14.9237C0.447715 14.9237 0 15.3714 0 15.9237C0 16.476 0.447715 16.9237 1 16.9237H20.8983V14.9237ZM8.36139 19.4042C8.53989 19.0943 8.8703 18.9033 9.22793 18.9033H12.6703C13.028 18.9033 13.3584 19.0943 13.5369 19.4042C13.7154 19.7141 13.7148 20.0958 13.5353 20.4051C13.0005 21.3272 12.0151 21.8947 10.9491 21.8947C9.88316 21.8947 8.89781 21.3272 8.36293 20.4051C8.18348 20.0958 8.1829 19.7141 8.36139 19.4042Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.603d5217.svg";
export { ForwardRef as ReactComponent };